module.exports = __webpack_public_path__ + "img/Lightning.a8cd55aa.png";